import { ethers } from "ethers";
import { USDT_ADDRESS, USDT_ABI, NEXAURA_ADDRESS } from "../config/contract";

export function getUsdtContract(signerOrProvider) {
  return new ethers.Contract(USDT_ADDRESS, USDT_ABI, signerOrProvider);
}

export async function getUsdtBalance(provider, account) {
  const c = getUsdtContract(provider);
  return c.balanceOf(account);
}

export async function getAllowance(provider, account) {
  const c = getUsdtContract(provider);
  return c.allowance(account, NEXAURA_ADDRESS);
}

// Ensure allowance >= needed. Approves max if not. Returns true when ready.
// onStatus(message) lets the caller surface progress without callbacks-into-state.
export async function ensureAllowance(signer, account, provider, needed, onStatus) {
  const current = await getAllowance(provider, account);
  if (current.gte(needed)) return true;

  if (onStatus) onStatus("Approve USDT in your wallet…");
  const c = getUsdtContract(signer);
  const tx = await c.approve(NEXAURA_ADDRESS, ethers.constants.MaxUint256);
  if (onStatus) onStatus("Confirming approval…");
  await tx.wait();
  return true;
}
